<section class="update-details">
  <div class="container text-center">

    <h2 class="update-details__title mb-3">Update your details</h2>
    <p class="update-details__body mb-4">
      It's quick and easy to keep your details up-to-date through your dashboard.
    </p>

    <div class="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-3">
      <a routerLink="/login" class="btn ui-btn ui-btn--outline-light fw-bold">Log in</a>
      <span class="update-details__or">or</span>
      <a routerLink="/register" class="btn ui-btn ui-btn--primary fw-bold">Register</a>
    </div>

  </div>
</section>
